export default function PhoneNumberFormatter(number) {
  if (!number) {
    return ""
  }
  if (typeof number === "number") {
    number.toString()
  }
  return number.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
}
